import { Button, LoadIndicator, Tooltip } from "devextreme-react";
import { fetchNetsuiteIntegration, fetchNetsuiteLastUpdate, fetcher, postNotification } from "../../actions";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import useSwr from "swr";
import { NetsuiteProgressModal } from "./NetsuiteProgressModal";
import "./NetsuiteUpdateButton.css";


export const NetsuiteUpdateButton = (props) => {
    const { origin } = props;
    const [isSyncing, setIsSyncing] = useState(false);
    const [showProgressModal, setShowProgressModal] = useState(false);
    const { data, isLoading, mutate } = useSwr('/api/serviceStatus/NETSUITE', fetcher, { refreshInterval: 10000 })
    
    // Also fetch progress details when syncing
    const netsuiteApiUrl = process.env.REACT_APP_NETSUITE_API;
    const { data: progressData } = useSwr(
        isSyncing && netsuiteApiUrl ? `${netsuiteApiUrl}/api/Netsuite/progress` : null,
        fetcher,
        { refreshInterval: 2000 }
    );

    const dispatch = useDispatch();
    const permissions = useSelector(state => state.userInfo.feature);
    const btnId = `btnNetsuite-${origin}`;



    useEffect(() => {
        if (data) {
            const isCurrentlySyncing = data.status !== "IDLE";
            
            // If integration just completed, we can close the progress modal
            if (isSyncing && !isCurrentlySyncing) {
                // Integration completed, you could show a completion notification here
                dispatch(fetchNetsuiteLastUpdate()); // Refresh the last update info
            }
            
            setIsSyncing(isCurrentlySyncing);
        }
    }, [data, isSyncing, dispatch]);


   
    const updateFromNetsuite = () => {
        const updateFromNetsuiteAsync = async () => {
            const notification = {
                type: "NETSUITE",
                status: "STARTED",
                message: "Netsuite Sync Started.",
            };
            await postNotification(notification);
            dispatch(fetchNetsuiteLastUpdate());
            dispatch(fetchNetsuiteIntegration());
            mutate();
        }
        updateFromNetsuiteAsync();
        setIsSyncing(true);
    }

    if (!permissions) {
        return "";
    }

    const SyncPermissions = permissions.find(x => x.NameFeature === "Manual Update");
    if (!SyncPermissions) {
        return "";
    }


    if (isLoading){
        return (
        <div>

            <Button width={180} height={40} icon="sorted" text="Netsuite Update" id={btnId} >
                <LoadIndicator className="button-indicator" visible={true} />
                <span className="dx-button-text">Loading Netsuite Service Status</span>
            </Button>
            <Tooltip
                target={`#${btnId}`}
                showEvent="mouseenter"
                hideEvent="mouseleave"
                hideOnOutsideClick={false}
            >
                <div>Retrieve the latest data changes from Netsuite.</div>
            </Tooltip>
        </div>
    );
    }

    const handleProgressClick = () => {
        if (isSyncing) {
            setShowProgressModal(true);
        } else {
            updateFromNetsuite();
        }
    };

    const getButtonText = () => {
        if (isSyncing) {
            // Use progress data first, then fallback to service status data
            const progressInfo = progressData || data;
            if (progressInfo) {
                const currentTask = progressInfo.currentTask || progressInfo.message || 'Processing...';
                return currentTask;
            }
        }
        return "Netsuite Update";
    };

    const getButtonIcon = () => {
        if (isSyncing) {
            return null; // No icon during sync, we'll show progress circle via CSS
        }
        return "sorted";
    };

    const getTooltipText = () => {
        if (isSyncing) {
            return "Click to view detailed progress";
        }
        return "Retrieve the latest data changes from Netsuite.";
    };

    const getProgressPercentage = () => {
        if (isSyncing) {
            // Use progress data first, then fallback to service status data
            const progressInfo = progressData || data;
            if (progressInfo) {
                // Try different possible property names for percentage
                const percentage = progressInfo.percentComplete || progressInfo.percentage || progressInfo.progress || 0;
                console.log('Service status data:', data);
                console.log('Progress data:', progressData);
                console.log('Using percentage:', percentage);
                return Math.round(percentage);
            }
        }
        return 0;
    };

    return (
        <div className="netsuite-button-wrapper">
            <Button 
                width={180} 
                height={40} 
                icon={getButtonIcon()}
                text={getButtonText()}
                onClick={handleProgressClick} 
                id={btnId}
                className={`netsuite-update-button ${isSyncing ? 'syncing' : ''}`}
                elementAttr={{
                    'data-progress': getProgressPercentage()
                }}
            />
            
            {isSyncing && (
                <div className="netsuite-progress-overlay">
                    <div className="netsuite-button-progress-circle">
                        <span className="netsuite-button-progress-number">{getProgressPercentage()}</span>
                        <span className="netsuite-button-progress-percent">%</span>
                    </div>
                </div>
            )}
            
            <Tooltip
                target={`#${btnId}`}
                showEvent="mouseenter"
                hideEvent="mouseleave"
                hideOnOutsideClick={false}
            >
                <div>{getTooltipText()}</div>
            </Tooltip>

            <NetsuiteProgressModal
                visible={showProgressModal}
                onClose={() => setShowProgressModal(false)}
            />
        </div>
    );

}
